import React from 'react';
import { useNavigate } from 'react-router';
import { MessageSquare, Image, Activity } from 'lucide-react';
import { APP_VERSION } from '../../utils/constants';

export default function Lab() {
  const navigate = useNavigate();

  const navigationItems = [
    {
      title: 'Analysis',
      icon: <Activity className="w-12 h-12" />,
      path: '/analysis',
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      title: 'Chat',
      icon: <MessageSquare className="w-12 h-12" />,
      path: '/chat',
      color: 'bg-green-500 hover:bg-green-600'
    },
    {
      title: 'Image Inverter',
      icon: <Image className="w-12 h-12" />,
      path: '/imageinverter',
      color: 'bg-purple-500 hover:bg-purple-600'
    },
    {
      title: 'Prompt Management',
      icon: <MessageSquare className="w-12 h-12" />,
      path: '/prompt-management',
      color: 'bg-amber-500 hover:bg-amber-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-800 mb-12 text-center">
          Orca Lab <span className="text-sm text-gray-500">v{APP_VERSION}</span>
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {navigationItems.map((item, index) => (
            <button
              key={index}
              onClick={() => navigate(item.path)}
              className={`${item.color} rounded-xl p-8 flex flex-col items-center justify-center text-white transition-all duration-300 transform hover:scale-105 shadow-lg`}
            >
              <div className="mb-4">
                {item.icon}
              </div>
              <h2 className="text-2xl font-semibold">{item.title}</h2>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
} 